// extracted by mini-css-extract-plugin
module.exports = {"cta--heading":"Cta_cta--heading__3-xE8"};